<template>
  <md-dialog
      class="tm-gal-dialog"
      :md-active.sync="showDialog11"
      @md-closed="$emit('hide', true)"
      @md-clicked-outside="$emit('hide', true)"
      :md-clicked-outside="true"
      :md-close-on-esc="true"
  >
    <div class="uk-padding uk-position-relative tm-modal-page">
      <a href="#" class="uk-position-top-right tm-dialog-close" @click="$emit('hide', true)">
        <span class="material-icons">close</span>
      </a>
      <div class="uk-grid uk-flex-middle_">
        <div class="uk-width-1-2">
          <div class="tm-block-img uk-text-center tm-width-1-1 before-after-block">
            <img class="alter-photo"
                 v-if="image !== null"
                 :src="image" alt="">
            <img class="alter-photo" v-else src="/img/images.png" alt="">
          </div>
        </div>
        <div class="uk-width-expand">
          <!-- поля цветных комментариев -->
          <div class="uk-grid uk-grid-small uk-child-width-1-3" data-uk-grid>
            <div v-for="(note, color) in comments"  :class="color" :key="color">
              <div class="uk-grid uk-grid-small uk-flex-middle">
                <md-icon :class="`${color}-note`">mode_edit</md-icon>
                <div>
                  {{ note }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </md-dialog>
</template>

<script>
export default ({
  name: "ColorNotesDialog",
  props: {
    modalColorNotesData: Object,
    showDialog11: Boolean
  },
  data() {
    return {
      image: null,
      comments: [],
    };
  },
  methods: {
    prepareColorNotesDialog() {
      let data = this.modalColorNotesData;
      if (data) {
        this.image = data.image;
        let comments = JSON.parse(data.comments);
        this.comments = Object.keys(comments).reduce((acc, key) => {
          const color = key.replace('_note', '');
          const noteValue = comments[key].trim(); // Trim whitespace
          if (noteValue !== "") {
            acc[color] = noteValue;
          }
          return acc;
        }, {});
      }
    },
  },
  watch: {
    modalColorNotesData: {
      handler(newVal, oldVal) {
        this.prepareColorNotesDialog();
      },
      deep: true,
    },
  },
})
</script>

<style scoped>

</style>